/**
 * Layout Component
 * Header + HamburgerMenu + Footer를 포함하는 전역 레이아웃
 * login 페이지를 제외한 모든 페이지에 적용
 */
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Header } from './Header';
import { HamburgerMenu } from './HamburgerMenu';
import { Footer } from '../organisms/Footer';
import { extractReferralCodeFromURL, saveReferralCodeToCookie } from '../../utils/referral';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);

  // URL 파라미터에서 추천인 코드 감지 및 쿠키 저장
  useEffect(() => {
    const referralCode = extractReferralCodeFromURL();
    if (referralCode) {
      saveReferralCodeToCookie(referralCode);
    }
  }, []);

  return (
    <PageWrapper>
      <Container>
        <Header onMenuClick={() => setMenuOpen(true)} menuButtonRef={menuButtonRef} />
        <HamburgerMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} menuButtonRef={menuButtonRef} />
        <MainContent>{children}</MainContent>
        <Footer />
      </Container>
    </PageWrapper>
  );
};

const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;
`;

const Container = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
